import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Cases() {
  const [casesList, setCasesList] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // Фильтруем по категории "cases"
        const filteredCases = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'cases'
        );

        setCasesList(filteredCases);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="cases">
      <h1>Корпуса</h1>
      <div className="cases__list">
        {casesList.length > 0 ? (
          casesList.map((pcCase) => (
            <div key={pcCase.id} className="cases__card">
              <img src={pcCase.image} alt={pcCase.name} />
              <div className="cases__card-content">
                <h2>{pcCase.name}</h2>
                <p className="specs">{pcCase.description}</p>
                <p className="price">{pcCase.price}</p>

                <Link to={`/components/cases/${pcCase.id}`} className="btn">
                  Подробнее
                </Link>
              </div>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
